import React from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import { useState } from "react";
import { getWareHouseStoreChallanQrCode } from "../../services/ChallanApi/Challan";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Accordion, AccordionTab } from "primereact/accordion";
import { formatDate, localeDateEndDate, localeDateStartDate } from "../../constants/DateUtil/DateUtil";

const ChallanQrCodeList = () => {
  const navigate = useNavigate();

  const { storeData } = getUserData();

  const storeId = storeData.id;
  const enabledGarmentInspection = storeData.enabledGarmentInspection;

  const location = useLocation();
  const { data } = location.state || {}; // Fallback to prevent undefined errors

  const [challanQrCodeData, setChallanQrCodeData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [dataProvider, setDataProvider] = useState([]);
  //   new DataProvider((r1, r2) => r1 !== r2),

  // const layoutProvider = new LayoutProvider(
  //   index => {
  //     return dataProvider.getDataForIndex(index).isExpanded
  //       ? 'EXPANDED'
  //       : 'NORMAL';
  //   },
  //   (type, dim) => {
  //     dim.width = windowWidth;
  //     dim.height =
  //       type === 'EXPANDED'
  //         ? windowWidth >= 620
  //           ? 240
  //           : windowWidth > 420 && windowWidth < 620
  //           ? 210
  //           : 180
  //         : windowWidth >= 620
  //         ? 55
  //         : windowWidth > 420 && windowWidth < 620
  //         ? 47
  //         : 40; // Adjust height for expanded/collapsed rows
  //   },
  // );

  // const handleShowHide = useCallback(
  //   index => {
  //     const newData = dataProvider.getAllData().map((item, i) => {
  //       if (i === index) {
  //         return {...item, isExpanded: !item.isExpanded};
  //       }
  //       return item;
  //     });
  //     setDataProvider(dataProvider.cloneWithRows(newData));
  //   },
  //   [dataProvider],
  // );

  const fetchChallanQrCodeList = (data) => {
    getWareHouseStoreChallanQrCode(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setChallanQrCodeData(Res);
          setDataProvider(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    if (data) {
      const requestData = {
        startDate: localeDateStartDate(new Date(data.createdDate)),
        endDate: localeDateEndDate(new Date(data.createdDate)),
        wareHouseStoreIdIn: [data.wareHouseStoreId],
        challanTypeStatusIn: [data.challanTypeStatus],
        challanIdIn: [data.id],
        qrCodeStatusIn: [],
        recordType: "",
      };

      fetchChallanQrCodeList(requestData);
    }
  }, [data]);

  useEffect(() => {
    if (!searchTerm) {
      setDataProvider(challanQrCodeData);
    } else {
      const suggestions = challanQrCodeData.filter((item) =>
        item?.qrCodeInfo?.qrCode
          .toLowerCase()
          .startsWith(searchTerm.toLowerCase())
      );
      setDataProvider(suggestions);
    }
  }, [searchTerm, challanQrCodeData]);

  const rowRenderer = () => {
    return dataProvider?.map((item, index) => {
      const OrderStatusColors = {
        DEFAULT: "#3EB3E1",
      };

      const orderStatusColor =
        OrderStatusColors[item.status] || OrderStatusColors.DEFAULT;
      const deliveryOn = formatDate(item.qrCodeInfo.deliveryOn);

      const str = item.qrCodeInfo.qrCode;
      const billNo = str.match(/.*(?=OI)/)[0];

      return (
        <Accordion>
          <AccordionTab
            key={index}
            style={{
              "--backgroundColor-AccordionTab": orderStatusColor,
            }}
            header={`${index + 1 || "N/A"} | ${item.qrCodeInfo.qrCode}`}
          >
            <div>
              <div className="flex-row">
                <div className="col-3">
                  <p className="text-base font-semiBold capitalize">
                    Garment Name:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {item.qrCodeInfo.garmentName.replace(/_/g, " ")}
                  </p>
                </div>
                <div className="col-3">
                  <p className="text-base font-semiBold capitalize">Status:</p>
                  <p className="text-lg font-bold capitalize">
                    {item.qrCodeInfo.status.replace(/_/g, " ")}
                  </p>
                </div>
                <div className="col-3">
                  <p className="text-base font-semiBold capitalize">
                    Delivery On:
                  </p>
                  <p className="text-lg font-bold capitalize">{deliveryOn}</p>
                </div>
                <div className="col-3">
                  <p className="text-base font-semiBold capitalize">
                    Bill No.:
                  </p>
                  <p className="text-lg font-bold capitalize">{billNo}</p>
                </div>
              </div>
              <div className="flex-row">
                <div className="col-3">
                  <p className="text-base font-semiBold capitalize">
                    Processed:
                  </p>
                  {item.qrCodeInfo.reProcess === true ? (
                    <img
                      src={
                        "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                      }
                    />
                  ) : (
                    <img
                      src={
                        "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                      }
                    />
                  )}
                </div>
                <div className="col-3">
                  <p className="text-base font-semiBold capitalize">
                    Re Process:
                  </p>
                  {item.qrCodeInfo.processed === true ? (
                    <img
                      src={
                        "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                      }
                    />
                  ) : (
                    <img
                      src={
                        "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                      }
                    />
                  )}
                </div>
                <div className="col-3">
                <p className="text-base font-semiBold capitalize">
                    Garment Image:
                  </p>
                {enabledGarmentInspection && (
                  <div className="ml-5 cursor-pointer">
                    <i
                      className="pi pi-image"
                      onClick={() =>
                        navigate("/WarehouseGarmentInspectionImages", {
                          state: {
                            QrCodeInfo: item,
                             FROM_WHERE: "OBJECT"
                          },
                        })
                      }
                      style={{
                        fontSize: "27px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>
                )}
                </div>
                {item?.qrCodeInfo?.garmentPack  && <div className="col-3">
                  <p className="text-base font-semiBold capitalize">
                    Packing Type:
                  </p>
                  <p className="text-lg font-bold capitalize">{item?.qrCodeInfo?.garmentPack}</p>
                </div>}
              </div>
            </div>
          </AccordionTab>
        </Accordion>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate(-1)}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold">Challan Tag</p>
            </div>
          </div>
        </div>
      </div>

      <div style={{ marginBottom: 80, marginTop: 10 }}>
        <div className="mt-2 mx-4 flex">
          <div className=" flex flex-1">
            <IconField iconPosition="left" className="flex flex-1">
              <InputIcon className="pi pi-search text-xl"> </InputIcon>
              <InputText
                placeholder="Enter Bill No."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="text-xl flex flex-1 py-1 px-5"
                style={{ borderRadius: 30 }}
                keyboardType="numeric"
              />
            </IconField>
          </div>
          {searchTerm.length > 0 && (
            <div
              className="mx-3 cursor-pointer"
              onClick={() => setSearchTerm("")}
            >
              <p className="text-3xl font-Bold" style={{ color: "red" }}>
                X
              </p>
            </div>
          )}
        </div>
        <div className="mx-4 mt-2">
          {dataProvider.length > 0 ? (
            rowRenderer()
          ) : (
            <div className="flex-1 flex flex-column justify-content-center align-items-center">
              <p className="text-3xl font-Bold">No Data Present...</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChallanQrCodeList;
